import React from "react";
import AuthorizationsGrid from "./AuthorizationsGrid";

const Authorizations = () => {
  return (
    <div className="h-100 w-100">
      <AuthorizationsGrid />
    </div>
  );
};

export default Authorizations;
